import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { CertificateNavigationItem } from '../models/certificate-navigation-item.model'
import { AbstractContentSidebarStateService } from './abstract-content-sidebar-state.service'

@Injectable({
  providedIn: 'root'
})
export class InsuredCertificatesStateService extends AbstractContentSidebarStateService<CertificateNavigationItem> {
  public readonly certificateList$ = this.itemList$
  protected override readonly apiUrl = environment.certificateApiUrl
  protected override readonly subsystemName = 'Insured Certificate List Loading'
  protected override readonly errorDescription = 'Could not load the list of Certificates for this Insured.'
  protected override readonly listEndpoint = 'navigation-list'
  protected override readonly useCategory = true
}
